import { ArrowLeftOutlined } from '@ant-design/icons'
import classNames from 'classnames'
import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

import { getLogoByHost } from '@/utils/organisation/getLogoByHost'

import cn from './AuthLayout.module.scss'

type AuthLayoutBack = {
  label: string
  onClick: () => void
}

type AuthLayoutProps = {
  title: string
  children: ReactNode
  back?: AuthLayoutBack
  onLogoDoubleClick?: () => void
}

function AuthLayout({
  title,
  children,
  back,
  onLogoDoubleClick,
}: AuthLayoutProps) {
  return (
    <section className={cn.layout}>
      <div className={cn.aurora} aria-hidden>
        <span className={cn.auroraBrand} />
        <span className={cn.auroraAccent} />
        <span className={cn.auroraWarm} />
      </div>

      <div className={cn.card}>
        {back && (
          <button
            type="button"
            className={cn.backButton}
            onClick={back.onClick}
            aria-label={back.label}
            title={back.label}
          >
            <ArrowLeftOutlined aria-hidden />
          </button>
        )}
        <div className={cn.header}>
          {onLogoDoubleClick ? (
            <span className={cn.logoBox}>
              <img
                src={getLogoByHost()}
                alt="Логотип"
                className={cn.logo}
                onDoubleClick={onLogoDoubleClick}
              />
            </span>
          ) : (
            <Link
              to="/"
              className={classNames(cn.logoBox, cn.logoLink)}
              aria-label="На главную"
            >
              <img src={getLogoByHost()} alt="Логотип" className={cn.logo} />
            </Link>
          )}
          <h1 className={cn.title}>{title}</h1>
        </div>
        {children}
      </div>
    </section>
  )
}

export default AuthLayout
